<!-- 各项目能耗 each -->
<template>
  <div class="mydayPowerQuality">
    <div class="con">
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small mr-20">
                <div class="select">
                  <div class="span" :class="{'active':selectDate_index == i}" v-for="(e ,i) in selectDate"
                    @click="selectDate_fn(i)">{{e}}</div>
                </div>
              </div>
              <div class="input-small ">
                <span>日期：</span>
                <el-date-picker v-model="yearTimer" type="daterange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
              <el-button type="primary" plain @click="getSearch" class="search-btn">查询</el-button>
            </div>
          </el-scrollbar>


        </div>
        <div class="mychart" :style="{'width':'100%','height':`${chartHeights}px`}">
          <div id="proportion" style="width:100%;height:100%"></div>
        </div>
        <div class="mytable" style="margin-top:10px;display: flex;">
          <el-table :data="dataList" :max-height="tabHeights" border :row-class-name="tableRowClassName">
            <template slot="empty">
              <span class="noData">
                <img src="../../assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column label="项目名称" width="200" align="center">
              <template slot-scope="{row}">
                <span>{{row.a }}</span>
              </template>
            </el-table-column>
            <el-table-column v-for="(a,i) in column" :key="i" :label="a" width="150" align="center">
              <template slot-scope="{row}">
                <span>{{row.b }}</span>
              </template>
            </el-table-column>

          </el-table>

        </div>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
  import elUnitTree from '@/components/module/newTree/elUnitTree.vue'
  import {getCountPower} from "../../api/abbNewApi";
  import {parseTime} from "@/utils";
  let proportion;
  export default {
    components: {
      elUnitTree
    },
    props: [],
    data () {
      return {
        selectDate: ['整体能耗','各项目能耗','同环比分析',],
        selectDate_index: 1,
        loading: false,
        chartHeights: Math.round((document.getElementById('app').clientHeight)*0.53),
        tabHeights: Math.round((document.getElementById('app').clientHeight)*0.28),
        yearTimer: '',
        dataList: [
          {
            a: 'A栋一层低压配电站',
            b: '6770.00'
          },
          {
            a: 'A栋二层低压配电站',
            b: '2370.00'
          },
          {
            a: 'A栋三层低压配电站',
            b: '1170.00'
          },
          {
            a: 'A栋四层低压配电站',
            b: '330.00'
          },
        ],
        proportionData: {
          legend: {
            top: 10
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '8%',
            containLabel: true
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // Use axis to trigger tooltip
              type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
            },
          },
          toolbox: {
            show: true,
            showTitle: true, // 隐藏默认文字，否则两者位置会重叠
            right: "35",
            top: "20",
            feature: {
              magicType: {
                type: ['line','bar','stack','tiled'],title: {
                  line: '切换为折线图',
                  bar: '切换为柱状图',
                  stack: '切换为堆叠',
                  tiled: '切换为平铺',
                }
              },
              saveAsImage: {
                show: true,
                title: '下载图片'
              },
              // dataView: { show: true, readOnly: true, lang: ['', '关闭'] },
            },
            tooltip: { // 和  .tooltip 的配置项相同
              show: true,
              formatter: function(param) {
                return '<div>'+param.title+'</div>'; // 自定义的 DOM 结构
              },
              backgroundColor: '#fff',
              textStyle: {
                fontSize: 12,
              },
              extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' // 自定义的 CSS 样式
            }
          },

          xAxis: {
            splitLine: {
              //网格线
              show: false,
            },
            type: "category",

            axisTick: {
              show: false,
            },
            axisLabel: {
              interval: 0,
              rotate: 0,
              inside: false,

            },
            axisLine: {
              show: false,
            },
            z: 99,
            data: ['23-09-30','23-10-01','23-10-02','23-10-03','23-10-04','23-10-05','23-10-06','23-10-06','23-10-07','23-10-08','23-10-09','23-10-10','23-10-11','23-10-12'],
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              name: 'A栋一层低压配电站',
              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
            {
              name: 'A栋二层低压配电站',
              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
            {
              name: 'A栋三层低压配电站',
              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
            {
              name: 'A栋四层低压配电站',
              data: [120,200,150,80,70,110,130,120,200,150,80,70,110,130],
              type: 'bar',
              barGap: 0,
            },
          ],
        },
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        column: [],
      }
    },
    mounted () {
      this.column=[];
      var a=new Date('2023-09-30').getTime();
      for(let i=0;i<16;i++) {
        this.column.push(parseTime(a+86400000*i,"{y}-{m}-{d}"))
      }
      //初始化图表
      this.init()
    },
    methods: {
      selectDate_fn (v) {
        console.log(v);
        if(v===0) {
          this.$router.push("/statistics")
        }
        if(v===1) {
          this.$router.push("/each")
        }
        if(v===2) {
          this.$router.push("/proportion")
        }
      },
      tableRowClassName ({row,rowIndex}) {
        if(rowIndex===2) {
          return 'success-row';
        }
        return '';
      },
      // 搜索
      getSearch () {
        this.search()
      },

      // 初始化
      init () {
        proportion=echarts.init(document.getElementById("proportion"));
        proportion.setOption(this.proportionData,true);

      },
    }
  }
</script>
<style>
  .mydayPowerQuality .el-table .success-row .row_box .txt {
    color: #0081cf;
  }

  .mydayPowerQuality .el-table .success-row .row_box .unit {
    color: #0081cf;
  }
</style>
<style scoped lang="scss">
  .echarted {
    width: 350px;
    position: relative;
  }

  .echarted .today {
    position: absolute;
    bottom: 0;
    left: 47%;
  }

  .echarted .top {
    display: flex;
    justify-content: space-around;
    height: 43px;
    line-height: 43px;

  }

  .echarted .top span {
    flex: 1;
    border-bottom: 3px solid #000;
    text-align: center;
  }

  .row_box {
    display: flex;
    justify-content: space-between;
    padding: 0 50px;
  }

  .row_box .txt {
    font-size: 16px;
    color: #000;
    font-weight: bold;
  }

  .row_box .unit {
    font-size: 12px;
    margin-top: 20px;
  }

  .select {
    display: flex;
    border: 1px solid #C0C4CC;
    border-right: none;
  }

  .select .span {
    border-right: 1px solid #C0C4CC;
    width: 170px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
  }

  .select .active {
    background: #ba0f1b;
    color: #fff;
  }

  .mydayPowerQuality {
    .con {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;

      .search-input-btn {
        margin-bottom: 0px;
      }

      .tree-left {
        width: 3rem;
        height: 100%;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        margin-right: 8px;

        .btns {
          display: flex;
          // justify-content: space-evenly;
          margin-bottom: 8px;

          button {
            margin-right: 12px;
          }

          .el-button--mini {
            padding: 7px 10px !important;
          }

          .el-button+.el-button {
            margin-left: 0px;
          }
        }

        .search {
          display: flex;
          justify-content: center;
          margin-bottom: 12px;
        }

      }

      .right-table {
        width: 100%;
        height: 100%;
        padding: 2px 20px 20px 20px;
        box-sizing: border-box;
        background-color: #fff;
        position: relative;
      }
    }
  }
</style>